import { VehicleStatus } from "@/api-schema-enums";
import { VEHICLE_STATUS_TRANSLATION_KEYS } from "@/common/helpers/vehicle-status";
import i18next from "i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_STATUS_BASE_VALUES = [
  VehicleStatus.UNKNOWN,
  VehicleStatus.Incoming,
  VehicleStatus.InStock,
  VehicleStatus.Sold,
] as const satisfies readonly VehicleStatus[];
const VEHICLE_STATUS_ADMIN_VALUES = [
  VehicleStatus.Historic,
  VehicleStatus.ZGMAdmin,
] as const satisfies readonly VehicleStatus[];

function getVehicleStatusOptions(showAdminStatuses: boolean): { id: VehicleStatus; name: string }[] {
  const values: readonly VehicleStatus[] = showAdminStatuses
    ? [...VEHICLE_STATUS_BASE_VALUES, ...VEHICLE_STATUS_ADMIN_VALUES]
    : VEHICLE_STATUS_BASE_VALUES;
  return values.map((status) => ({
    id: status,
    name: i18next.t(VEHICLE_STATUS_TRANSLATION_KEYS[status]),
  }));
}

export class VehicleStatusFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "vehicleStatus";
  readonly labelSingular = "common:Status";
  readonly labelPlural = "common:Status";
  readonly placeholder = "masterdata:SelectVehicleStatus";
  readonly searchPlaceholder = "masterdata:SearchVehicleStatus";
  readonly emptyText = "masterdata:NoVehicleStatusFound";
  body = {};
  parameters = {};
  private readonly showAdminStatuses: boolean;

  constructor({ id, showAdminStatuses = false }: { id?: string; showAdminStatuses?: boolean } = {}) {
    super();
    if (id) this.id = id;
    this.showAdminStatuses = showAdminStatuses;
  }

  getData(): FilterData {
    return {
      options: getVehicleStatusOptions(this.showAdminStatuses),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
